// shoop by look popup
function handleChange(e) {
  if (e.target.closest(".MainVariants .VariantOptions input")) {
    var text = ''; 
    var variantOptions = e.target.closest(".ProductsVariants").querySelectorAll(".VariantOptions input");
    variantOptions.forEach(function(input) {
      if (input.checked) {
        text += input.value + " / ";
      }
    });
    var newname = text.slice(0, -2).trim();
    var productsVariants = e.target.closest(".ProductsVariants");
     var productsVariants1 = e.target.closest(".ProductDeatils");
    var getQuantity = e.target.closest(".MainVariants .VariantOptions");
    var inputs = productsVariants.querySelectorAll("input");
    var variant_id;
    inputs.forEach(function(input) {
      if (input.checked) {
        var option = productsVariants.querySelector('.hiddenSelector option[variant-title="' + newname + '"]');
        if (option) {
          variant_id = option.value;
          varint_price = option.getAttribute('variant_price');          
        }
      }
    });
    productsVariants1.querySelector('.ProductPrice').innerHTML = varint_price;
    productsVariants.querySelector('.CustomButton .ATCtext').setAttribute('data_id',variant_id);

  }
}

document.removeEventListener("change", handleChange);
document.addEventListener("change", handleChange);



document.addEventListener("click", function(event) {
  if (event.target.classList.contains("shoplook-add-btn") && event.target.classList.contains("btn")) {
    var get_var_id = event.target.closest('.CustomButton').querySelector(".ATCtext").getAttribute('data_id');
    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/add.js');
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onload = function() {
      if (xhr.status === 200) {
        var response = JSON.parse(xhr.responseText);
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: get_var_id,
          cartData: response
        });
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          cartDrawer.classList.add('active');
          cartDrawer.classList.remove('is-empty');
          var drawerInnerEmpty = document.querySelector('.drawer__inner-empty');
          if (drawerInnerEmpty) {
            drawerInnerEmpty.style.display = 'none';
          }
        }
fetch('/cart.js')
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  })
  .then(cart => {
   var cartItemCount = cart.item_count;
var cartCountSpan = document.querySelector(".cart-count-bubble span");
cartCountSpan.textContent = cartItemCount;

  })
  .catch(error => {
    console.error('There was a problem with the fetch operation:', error);
  });
      } else {
        console.error('Request failed.  Returned status of ' + xhr.status);
      }
    };
    xhr.send(JSON.stringify({ id: get_var_id, quantity: 1 }));
  }
});
document.addEventListener('click', function(event) {
  var videoButton = event.target.closest('.CustomFirst_Collage .VideoButton');  
  if (videoButton) {
    var shopProduct = document.querySelector('.ShopProduct');
    
    if (shopProduct) {
      shopProduct.classList.add('Active_Popup');
    }
  }
});
document.addEventListener('click', function(event) {
  var customCrossIcon = event.target.closest('.CustomCross_icon'); 
  if (customCrossIcon) {
    var shopProduct = document.querySelector('.ShopProduct');   
    if (shopProduct) {
      shopProduct.classList.remove('Active_Popup');
    }
  }
});
// Shop by look desciption 
document.addEventListener('DOMContentLoaded', function() {
    var showChar = 127;
    var ellipsestext = "";
    var moretext = "Read More";
    var lesstext = "Read Less";
    var lookBookDescriptions = document.querySelectorAll('.LookBook_description');
    lookBookDescriptions.forEach(function(lookBookDescription) {
        var content = lookBookDescription.innerHTML;
        if (content.length > showChar) {
            var c = content.substr(0, showChar);
            var h = content.substr(showChar, content.length - showChar);
            var html = c + '<span class="moreellipses">' + ellipsestext + '</span><span class="morecontent"><span>' + h + '</span><a href="#" class="morelink">' + moretext + '</a></span>';
            lookBookDescription.innerHTML = html;
        }
    });
   var moreLinks = document.querySelectorAll('.morelink');
    moreLinks.forEach(function(moreLink) {
        moreLink.addEventListener('click', function(event) {
            event.preventDefault();
            var isLess = this.classList.contains('less');
            if (isLess) {
                this.classList.remove('less');
                this.innerHTML = moretext;
            } else {
                this.classList.add('less');
                this.innerHTML = lesstext;
            }
            this.parentElement.previousElementSibling.style.display = isLess ? 'inline' : 'none';
            this.previousElementSibling.style.display = isLess ? 'none' : 'inline';
        });
    });
});

// Select the elements with class ".main_collage_product-popup-wrapp .VideoButton a.button"
var buttons = document.querySelectorAll(".main_collage_product-popup-wrapp .VideoButton a.button");

// Iterate through each button
buttons.forEach(function(button) {
    // Add event listener for 'click' event
    button.addEventListener("click", function(e) {
        // Prevent the default behavior of the anchor tag
        e.preventDefault();
        
        // Get the value of the 'productindex' attribute of the parent element
        var get_product_index = this.closest(".main_collage_product-popup-wrapp").getAttribute("productindex");
        
        // Check if 'productindex' is greater than 0
        if (get_product_index > 0) {
            // Add class 'show_products' to the parent element
            this.closest(".main_collage_product-popup-wrapp").classList.add("show_products");
            
            // Add class 'show_popup' to the body
            document.body.classList.add("show_popup");
        }
    });
});
// Selecting all elements with class "CustomCross_icon" inside elements with class "ShopProduct" and handling click event
document.querySelectorAll(".ShopProduct .CustomCross_icon svg").forEach(function(element) {
    element.addEventListener("click", function(event) {
        event.preventDefault(); // Preventing default behavior of the click event

        // Getting the index of the product
        var productWrapper = this.closest(".main_collage_product-popup-wrapp");
        var getProductIndex = productWrapper.getAttribute("productindex");

        // Checking if product index is greater than 0
        if (getProductIndex > 0) {
            // Removing the class "show_products" from the product wrapper
            productWrapper.classList.remove("show_products");

            // Removing the class "show_popup" from the body
            document.body.classList.remove("show_popup");
        }
    });
});

